type Props={userId:string;name:string;available?:boolean;className?:string;version?:number|string};

export function UserAvatar({userId,name,available=false,className='avatar',version}:Props){
  const initials=name.split(/\s+/).filter(Boolean).map(part=>part[0]).slice(0,2).join('').toUpperCase()||'?';
  if(!available)return <span className={className} aria-label={name}>{initials}</span>;
  const suffix=version===undefined?'':`?v=${encodeURIComponent(String(version))}`;
  return <span className={`${className} avatar-image`} aria-label={name}><img src={`/api/v1/enterprise/users/${userId}/avatar${suffix}`} alt="" onError={event=>{const image=event.currentTarget;image.hidden=true;image.parentElement?.classList.add('avatar-image-failed')}}/><i>{initials}</i></span>;
}
